import * as React from "react";

/**
 * Delay a rapidly-changing value. Used for search boxes so typing "rodriguez" is one request
 * rather than nine — each of which would also race the others to set the list.
 */
export function useDebounced<T>(value: T, delayMs = 250): T {
  const [debounced, setDebounced] = React.useState(value);
  React.useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(t);
  }, [value, delayMs]);
  return debounced;
}
